<template>
  <div
    class="pretty p-default p-smooth p-icon p-fill asc-checkbox asc-checkbox--accent"
    :class="[indeterminate ? 'p-has-indeterminate' : '']"
  >
    <input
      :id="`ascCheckbox${_uid}`"
      :ref="`ascCheckbox${_uid}`"
      type="checkbox"
      :checked="handleChecked"
      :aria-label="label"
      :value="value"
      :disabled="disabled"
      :required="required"
      @change="handleChange"
    />
    <div class="state p-primary">
      <i class="icon mdi mdi-check-bold"></i>
      <label :for="`ascCheckbox${_uid}`">{{ label }}</label>
    </div>
    <div v-if="indeterminate" class="state p-primary p-is-indeterminate">
      <i class="icon mdi mdi-minus"></i>
      <label :for="`ascCheckbox${_uid}`">{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AscCheckbox',

  model: {
    prop: 'modelValue',
    event: 'change',
  },

  props: {
    value: {},
    modelValue: {
      default: undefined,
    },
    trueValue: {
      type: [Boolean, String],
      default: true,
    },
    falseValue: {
      type: [Boolean, String],
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedBox: undefined,
    }
  },
  computed: {
    handleChecked() {
      if (this.modelValue !== undefined) {
        if (this.modelValue instanceof Array)
          return this.modelValue.includes(this.value)

        if (this._trueValue) return this.modelValue === this.trueValue

        return typeof this.modelValue === 'string' ? true : !!this.modelValue
      }
      if (this.checkedBox === undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return (this.checkedBox =
          typeof this.checked === 'string' ? true : !!this.checked)
      } else return this.checkedBox
    },
    _trueValue() {
      return typeof this.trueValue === 'string'
        ? this.trueValue
        : !!this.trueValue
    },
    _falseValue() {
      return typeof this.falseValue === 'string'
        ? this.falseValue
        : !!this.falseValue
    },
  },

  watch: {
    checked(newValue) {
      this.checkedBox = newValue
    },
    indeterminate(newValue) {
      this.$refs['ascCheckbox' + this._uid].indeterminate = newValue
    },
  },

  mounted() {
    if (this.indeterminate)
      this.$refs['ascCheckbox' + this._uid].indeterminate = true
  },

  methods: {
    handleChange(event) {
      this.$emit('update:indeterminate', false)
      const isChecked = event.target.checked
      this.checkedBox = isChecked

      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue]

        if (isChecked) newValue.push(this.value)
        else newValue.splice(newValue.indexOf(this.value), 1)

        this.$emit('change', newValue)
      } else {
        this.$emit(
          'change',
          isChecked
            ? this._trueValue
              ? this.trueValue
              : true
            : this._falseValue
            ? this.falseValue
            : false,
        )
      }
    },
  },
}
</script>

<style lang="scss">
.asc-checkbox {
  &--accent {
    &.pretty {
      .state {
        label {
          padding-left: 8px;
          padding-bottom: 2px;

          &::before {
            border-color: $gray-600;
          }
        }

        &.p-is-indeterminate {
          label {
            &::before {
              border-color: $gray-500;
            }
          }

          .icon {
            color: $gray-500;
          }
        }
      }

      input {
        &:checked {
          ~ {
            .state.p-primary {
              label {
                &::before {
                  border-color: $gray-600;
                }

                &::after {
                  background-color: $accent-400 !important;
                }
              }

              .icon {
                color: $primary-black;
              }
            }
          }
        }
      }
    }
  }
}
</style>
